import { encrypt, decrypt } from './cryptoService';

export const writeLocalStorage = (key, value) => {
  window.sessionStorage.setItem(key, encrypt(JSON.stringify(value)));
};

export const readLocalStorage = (key) => {
  return window.sessionStorage.getItem(key) ? JSON.parse(decrypt(window.sessionStorage.getItem(key))) : null;
};



// WEBPACK FOOTER //
// ./src/_override/context/storageService.js